/**
 * PRP-MCP-5 work item 4 (founder decision D2): the export disclaimer, shown in
 * small muted text next to the Download ESX control. The wording lives in one
 * place on the server (app/data/export_disclaimer.json) and is read from
 * GET /me/export-disclaimer, so the web bundle carries no copy of it. Nothing
 * here asks for a click or a confirmation. Renders nothing until the text
 * arrives, or if it cannot be read.
 */
import { useEffect, useState } from 'react';

import { BackendAPI } from '../../lib/api';

let cached: Promise<string> | null = null;

/** The stored text, fetched once per page load. */
function loadDisclaimer(): Promise<string> {
  if (!cached) {
    cached = Promise.resolve()
      .then(() => BackendAPI.getExportDisclaimer())
      .then((r) => r?.text ?? '')
      .catch(() => {
        cached = null; // try again next mount
        return '';
      });
  }
  return cached;
}

/** Test hook: forget the fetched text. */
export function resetExportDisclaimerCache(): void {
  cached = null;
}

export default function ExportDisclaimer({ className = '' }: { className?: string }) {
  const [text, setText] = useState('');
  useEffect(() => {
    let live = true;
    void loadDisclaimer().then((t) => {
      if (live) setText(t);
    });
    return () => {
      live = false;
    };
  }, []);
  if (!text) return null;
  return (
    <p
      className={`text-[10.5px] leading-snug ${className}`}
      style={{ color: 'var(--text-muted, #64748b)' }}
      data-testid="export-disclaimer"
    >
      {text}
    </p>
  );
}
